var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyPoundPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75c8.975 0 16.25 7.275 16.25 16.25a16.25 16.25 0 0 1-32.5 0c0-8.975 7.275-16.25 16.25-16.25zm0 2.5C12.406 6.25 6.25 12.406 6.25 20a13.75 13.75 0 0 0 27.5 0c0-7.594-6.156-13.75-13.75-13.75zm-2.08 4.107a6.25 6.25 0 0 1 6.499 1.474A1.25 1.25 0 1 1 22.65 13.6a3.75 3.75 0 0 0-3.9-.885 3.74 3.74 0 0 0-2.477 3.103c-.02.25-.009.502.038.783l.307 2.149L20 18.75c.641 0 1.17.483 1.242 1.104l.008.146c0 .69-.56 1.25-1.25 1.25l-3.024-.001.18 1.252a8.752 8.752 0 0 1-.025 2.64l-.065.352.104-.034a5 5 0 0 1 2.85-.092l.31.092 1.092.364a2.5 2.5 0 0 0 1.909-.136l1.11-.555a1.25 1.25 0 0 1 1.118 2.236l-1.11.555a5 5 0 0 1-3.817.271l-1.092-.363a2.5 2.5 0 0 0-1.58 0l-2.565.855c-1.055.352-2.01-.747-1.514-1.743l.203-.407a6.25 6.25 0 0 0 .597-3.68l-.23-1.607-.701.001a1.25 1.25 0 0 1-1.242-1.104L12.5 20c0-.69.56-1.25 1.25-1.25l.344-.001-.251-1.763a5.468 5.468 0 0 1-.076-1.04l.018-.363a6.25 6.25 0 0 1 4.135-5.226z",
    fill: "#8E06BF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyPoundPurple);
export default __webpack_public_path__ + "static/media/currency-pound-purple.9b35c2b530ec15eebf241406873898e4.svg";
export { ForwardRef as ReactComponent };